"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAgeStatusPriority = exports.EmailAgeStatusEnum = exports.EmailAgeStatus = void 0;
const zod_1 = require("zod");
var EmailAgeStatus;
(function (EmailAgeStatus) {
    EmailAgeStatus["AGE_DETECTED"] = "AGE_DETECTED";
    EmailAgeStatus["NO_EMAILS"] = "NO_EMAILS";
    EmailAgeStatus["UNABLE_TO_ACCESS_EMAIL"] = "UNABLE_TO_ACCESS_EMAIL";
    EmailAgeStatus["SIGNUP_INCOMPLETE"] = "SIGNUP_INCOMPLETE";
    EmailAgeStatus["GRANDFATHERED"] = "GRANDFATHERED";
    EmailAgeStatus["EMAIL_PARSING_NOT_SUPPORTED"] = "EMAIL_PARSING_NOT_SUPPORTED";
})(EmailAgeStatus || (exports.EmailAgeStatus = EmailAgeStatus = {}));
exports.EmailAgeStatusEnum = zod_1.z.nativeEnum(EmailAgeStatus);
/**
 * This is meant to define which statuses are more important than others. Discussion here...
 * https://app.clickup.com/t/86991b6xj?comment=90120124880245&threadedComment=90120125554062
 *
 * The status should essentially only be able to move up this priority order as we are handling
 * new sets of emails for a given user.
 */
exports.EmailAgeStatusPriority = {
    [EmailAgeStatus.AGE_DETECTED]: 5,
    [EmailAgeStatus.NO_EMAILS]: 4,
    [EmailAgeStatus.GRANDFATHERED]: 3,
    [EmailAgeStatus.EMAIL_PARSING_NOT_SUPPORTED]: 2.5,
    [EmailAgeStatus.UNABLE_TO_ACCESS_EMAIL]: 2,
    [EmailAgeStatus.SIGNUP_INCOMPLETE]: 1,
};
